
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Search } from 'lucide-react';

function SearchBar({ value, onChange }) {
  return (
    <div className="d-flex justify-content-center mb-4">
      <InputGroup
        className="shadow-sm"
        style={{
          maxWidth: 600,
          borderRadius: 999,
          overflow: 'hidden',
          backgroundColor: '#f1f3f4',
        }}
      >
        {/* SEARCH ICON */}
        <InputGroup.Text
          style={{
            background: 'transparent',
            border: 'none',
            paddingLeft: 16,
          }}
        >
          <Search size={18} />
        </InputGroup.Text>

        {/* INPUT */}
        <Form.Control
          placeholder="Search products"
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{
            border: 'none',
            background: 'transparent',
            boxShadow: 'none',
          }}
        />
      </InputGroup>
    </div>
  );
}

export default SearchBar;





{/*.  v1.4.4.
// src/components/SearchBar.js
import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="d-flex justify-content-center mb-4">
      <InputGroup
        className="w-100 w-md-75 w-lg-50 shadow-sm rounded-4"
        style={{ border: '1px solid #212529', overflow: 'hidden' }} // dark border
      >
        <InputGroup.Text className="bg-white border-end-0">
          <Search className="text-dark" />
        </InputGroup.Text>
        <FormControl
          type="text"
          placeholder="Search for products..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border-start-0 bg-white text-dark"
          style={{
            fontSize: '1rem',
            padding: '0.75rem 1rem',
            borderColor: '#212529', // dark border on input
          }}
        />
      </InputGroup>
    </div>
  );
};

export default SearchBar;

*/}